import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, Quote, Star, ArrowRight, Users, Award, BarChart, TrendingUp } from 'lucide-react';
export const TestimonialsPage = () => {
  const testimonials = [{
    quote: "Sapis Capital's strategic guidance and operational support were instrumental in helping us scale our business internationally. Their team's hands-on approach and deep industry knowledge made them invaluable partners.",
    author: 'Sarah Johnson',
    title: 'CEO, NexGen Technologies',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1522&q=80',
    rating: 5
  }, {
    quote: 'Beyond just capital, Sapis brought a level of expertise and connections that transformed our growth trajectory. They truly understand the challenges of scaling a business and provide solutions that work.',
    author: 'Michael Chen',
    title: 'Founder, DataSphere',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80',
    rating: 5
  }, {
    quote: 'Working with Sapis Capital has been a game-changer for our company. Their patient capital approach and focus on sustainable growth aligned perfectly with our vision for the business.',
    author: 'Robert Keller',
    title: 'President, FinCore Systems',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80',
    rating: 5
  }, {
    quote: "Their strategic insights and industry connections accelerated our growth in ways we couldn't have achieved alone. The Sapis team doesn't just provide capital; they become true partners in your success.",
    author: 'Amanda Torres',
    title: 'CEO, HealthConnect',
    image: 'https',
    rating: 5
  }, {
    quote: "Sapis Capital helped us navigate a challenging market transition and emerge stronger than before. Their team's operational expertise and strategic vision were exactly what we needed.",
    author: 'David Reynolds',
    title: 'CFO, SolarPeak',
    image: 'https',
    rating: 4
  }, {
    quote: "The Sapis team's ability to identify growth opportunities and provide the resources to capture them has been invaluable to our expansion strategy.",
    author: 'Jennifer Wu',
    title: 'COO, Urban Spaces',
    image: 'https',
    rating: 5
  }];
  const caseStudies = [{
    company: 'NexGen Technologies',
    industry: 'Technology',
    challenge: 'Scaling operations internationally while maintaining product quality and company culture',
    solution: 'Sapis Capital provided strategic guidance on market entry, helped recruit key international leadership, and structured a growth financing round that enabled controlled expansion.',
    results: ['85% revenue growth in 18 months', 'Successful expansion to 3 new international markets', 'Maintained 95% customer satisfaction through growth phase'],
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    icon: <TrendingUp size={24} className="text-[#38b2ac]" data-id="element-821" />
  }, {
    company: 'FinCore Systems',
    industry: 'Financial Technology',
    challenge: 'Navigating complex regulatory requirements while scaling a digital banking platform',
    solution: 'Sapis Capital connected FinCore with regulatory experts, helped optimize compliance processes, and provided capital to enhance their technology infrastructure.',
    results: ['Reduced compliance processing time by 40%', 'Successfully obtained licenses in 12 new jurisdictions', 'Secured partnerships with 5 major financial institutions'],
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    icon: <BarChart size={24} className="text-[#38b2ac]" data-id="element-822" />
  }, {
    company: 'HealthConnect',
    industry: 'Healthcare Technology',
    challenge: 'Accelerating adoption of telehealth services among traditional healthcare providers',
    solution: 'Sapis Capital developed a comprehensive go-to-market strategy, facilitated key industry partnerships, and provided capital for enhanced product development.',
    results: ['300% increase in provider adoption', 'Integration with 8 major electronic health record systems', 'Raised a $30M Series B round at 2.5x valuation increase'],
    image: 'https://images.unsplash.com/photo-1504439468489-c8920d796a29?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
    icon: <Users size={24} className="text-[#38b2ac]" data-id="element-823" />
  }];
  const partners = ['https://images.unsplash.com/photo-1572021335469-31706a17aaef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80', 'https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80', 'https://images.unsplash.com/photo-1572021335469-31706a17aaef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1572021335469-31706a17aaef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80'];
  return <div className="min-h-screen flex flex-col" data-id="element-824">
      <Header data-id="element-825" />
      <main className="flex-grow pt-20" data-id="element-826">
        {/* Hero Banner */}
        <section className="relative bg-[#0a2351] text-white" data-id="element-827">
          <div className="absolute inset-0 z-0 opacity-20" data-id="element-828">
            <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Testimonials background" className="w-full h-full object-cover" data-id="element-829" />
          </div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-10" data-id="element-830">
            <div className="max-w-3xl" data-id="element-831">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-832">
                Our Client Success Stories
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-2xl" data-id="element-833">
                Hear directly from the businesses we've partnered with on their
                journey to success
              </p>
              <nav className="flex" aria-label="Breadcrumb" data-id="element-834">
                <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-835">
                  <li className="inline-flex items-center" data-id="element-836">
                    <a href="/" className="text-gray-300 hover:text-white" data-id="element-837">
                      Home
                    </a>
                  </li>
                  <li data-id="element-838">
                    <div className="flex items-center" data-id="element-839">
                      <ChevronRight className="w-4 h-4 text-gray-300" data-id="element-840" />
                      <span className="ml-1 text-white md:ml-2" data-id="element-841">
                        Testimonials
                      </span>
                    </div>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="h-16 bg-gradient-to-b from-[#0a2351] to-white opacity-20" data-id="element-842"></div>
        </section>
        {/* Featured Testimonials */}
        <section className="py-20 bg-white" data-id="element-843">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-844">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-845">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-846">
                What Our Partners Say
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-847"></div>
              <p className="text-xl text-gray-600" data-id="element-848">
                Insights from business leaders who have partnered with Sapis
                Capital
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-849">
              {testimonials.slice(0, 3).map((testimonial, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-sm relative flex flex-col h-full" data-id="element-850">
                  <Quote className="absolute top-6 left-6 text-gray-200" size={40} data-id="element-851" />
                  <div className="relative flex-grow" data-id="element-852">
                    <div className="flex mb-4" data-id="element-853">
                      {[...Array(5)].map((_, i) => <Star key={i} size={18} className={i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} data-id="element-854" />)}
                    </div>
                    <p className="text-gray-600 italic mb-8 leading-relaxed" data-id="element-855">
                      "{testimonial.quote}"
                    </p>
                  </div>
                  <div className="flex items-center mt-auto" data-id="element-856">
                    <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-857" />
                    <div data-id="element-858">
                      <p className="font-semibold text-[#0a2351]" data-id="element-859">
                        {testimonial.author}
                      </p>
                      <p className="text-sm text-gray-500" data-id="element-860">
                        {testimonial.title}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Case Studies */}
        <section className="py-20 bg-gray-50" data-id="element-861">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-862">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-863">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-864">
                Success Stories
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-865"></div>
              <p className="text-xl text-gray-600" data-id="element-866">
                Real results from our strategic partnerships
              </p>
            </div>
            <div className="space-y-16" data-id="element-867">
              {caseStudies.map((study, index) => <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 bg-white rounded-lg shadow-md overflow-hidden`} data-id="element-868">
                  <div className="lg:w-1/2" data-id="element-869">
                    <img src={study.image} alt={study.company} className="w-full h-full object-cover" data-id="element-870" />
                  </div>
                  <div className="lg:w-1/2 p-8 flex flex-col justify-center" data-id="element-871">
                    <div className="flex items-center mb-4" data-id="element-872">
                      {study.icon}
                      <h3 className="text-2xl font-bold text-[#0a2351] ml-3" data-id="element-873">
                        {study.company}
                      </h3>
                    </div>
                    <p className="text-[#38b2ac] font-medium mb-4" data-id="element-874">
                      {study.industry}
                    </p>
                    <div className="mb-4" data-id="element-875">
                      <h4 className="font-semibold text-gray-800 mb-2" data-id="element-876">
                        Challenge:
                      </h4>
                      <p className="text-gray-600" data-id="element-877">{study.challenge}</p>
                    </div>
                    <div className="mb-4" data-id="element-878">
                      <h4 className="font-semibold text-gray-800 mb-2" data-id="element-879">
                        Solution:
                      </h4>
                      <p className="text-gray-600" data-id="element-880">{study.solution}</p>
                    </div>
                    <div data-id="element-881">
                      <h4 className="font-semibold text-gray-800 mb-2" data-id="element-882">
                        Results:
                      </h4>
                      <ul className="list-disc list-inside text-gray-600" data-id="element-883">
                        {study.results.map((result, i) => <li key={i} className="mb-1" data-id="element-884">
                            {result}
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* More Testimonials */}
        <section className="py-20 bg-white" data-id="element-885">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-886">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-887">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-888">
                More Partner Testimonials
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-889"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-890">
              {testimonials.slice(3).map((testimonial, index) => <div key={index + 3} className="bg-gray-50 p-8 rounded-lg shadow-sm relative flex flex-col h-full" data-id="element-891">
                  <Quote className="absolute top-6 left-6 text-gray-200" size={40} data-id="element-892" />
                  <div className="relative flex-grow" data-id="element-893">
                    <div className="flex mb-4" data-id="element-894">
                      {[...Array(5)].map((_, i) => <Star key={i} size={18} className={i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} data-id="element-895" />)}
                    </div>
                    <p className="text-gray-600 italic mb-8 leading-relaxed" data-id="element-896">
                      "{testimonial.quote}"
                    </p>
                  </div>
                  <div className="flex items-center mt-auto" data-id="element-897">
                    <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-898" />
                    <div data-id="element-899">
                      <p className="font-semibold text-[#0a2351]" data-id="element-900">
                        {testimonial.author}
                      </p>
                      <p className="text-sm text-gray-500" data-id="element-901">
                        {testimonial.title}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Partners Section */}
        <section className="py-16 bg-gray-50" data-id="element-902">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-903">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-904">
              <h2 className="text-3xl font-bold mb-4 text-[#0a2351]" data-id="element-905">
                Our Strategic Partners
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-906"></div>
              <p className="text-xl text-gray-600 mb-8" data-id="element-907">
                Working with leading organizations across industries
              </p>
            </div>
            <div className="flex flex-wrap justify-center items-center gap-12" data-id="element-908">
              {partners.map((partner, index) => <div key={index} className="grayscale hover:grayscale-0 transition-all duration-300" data-id="element-909">
                  <img src={partner} alt={`Strategic partner ${index + 1}`} className="h-16 object-contain" data-id="element-910" />
                </div>)}
            </div>
          </div>
        </section>
        {/* CTA Section */}
        <section className="py-16 bg-[#0a2351]" data-id="element-911">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-912">
            <div className="max-w-4xl mx-auto text-center" data-id="element-913">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-914">
                Ready to Write Your Success Story?
              </h2>
              <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto" data-id="element-915">
                Join the growing list of companies that have partnered with
                Sapis Capital to accelerate their growth and achieve their
                vision.
              </p>
              <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-916">
                <a href="/contact" className="inline-flex items-center justify-center bg-[#38b2ac] hover:bg-[#319795] text-white font-medium py-3 px-8 rounded-md transition-colors duration-300" data-id="element-917">
                  Contact Our Team
                  <ArrowRight size={18} className="ml-2" data-id="element-918" />
                </a>
                <a href="/portfolio" className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white font-medium py-3 px-8 rounded-md hover:bg-white hover:text-[#0a2351] transition-colors duration-300" data-id="element-919">
                  View Our Portfolio
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-920" />
    </div>;
};